import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Brands } from 'app/_models/brands';
import { Observable, Subject } from 'rxjs';
import { UserModel } from 'app/_models/user-model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CrudBrandService {
  _baseUrl = environment.baseUrl;
  constructor(
    private readonly http: HttpClient
     ) { }
  currentUser: UserModel;

  private readonly  _refreshrequired = new Subject<void>();

  get Refreshrequired() {
    return this._refreshrequired;
  }

  getActiveBrands() {
    return this.http.get<Brands[]>(this._baseUrl + 'Common/GetActiveBrands');
  }

  getPagedActiveBrands(model:any): Observable<any>{
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
    let options = { headers: headers,  withCredentials: true  };
    return this.http.post<any>(`${this._baseUrl}Common/GetActiveBrands`, model, options);
  }

  getAllBrands() {
    return this.http.get<Brands[]>(this._baseUrl + 'Common/GetAllBrands');
  }

  deleteBrand(brandId: number): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));
    let model = { id: brandId, updatedBy: this.currentUser.userId };
    return this.http.post<any>(`${this._baseUrl}Common/DeleteBrand/`, model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }

  saveBrand(model:any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}Common/SaveBrand/`, model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }

  updateBrand(model:any): Observable<any> {
    return this.http.post<any>(`${this._baseUrl}Common/UpdateBrand/`, model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }


}





